import { css } from '@emotion/react';

export const colors = {
  white: '#fff',
  black: '#333',
  blue: {
    primaryDark: '#0094ab',
    primary: '#00a6c2',
    primaryLight: '#17b7da',
    secondaryDark: '#57cadc',
    secondary: '#cff5fd',
    secondaryLight: '#ebfcff',
  },
  cs: {
    primaryDark: '#33a995',
    primary: '#3fB9A4',
    primaryLight: '#1AC7A9',
    secondaryDark: '#79CEBF',
    secondary: '#C5EAE3',
    secondaryLight: '#ebf8f5',
  },
  teal: {
    primaryDark: '#33a995',
    primary: '#3fB9A4',
    primaryLight: '#1AC7A9',
    secondaryDark: '#79CEBF',
    secondary: '#C5EAE3',
    secondaryLight: '#ebf8f5',
  },
  green: {
    primary: '#24B352',
    light: '#F0FFEB',
  },
  grey: {
    primary: '#666',
    primaryLight: '#999',
    altDark: '#aaa',
    altLight: '#c9c9c9',
    secondaryDark: '#d4d4d4',
    secondary: '#eee',
    secondaryLight: '#f8f8f8',
  },
  orange: {
    darkest: '#FF8C23',
    primary: '#FF8C23',
    lightest: '#FCE5D0',
  },
  red: {
    primary: '#E51D1D',
    secondary: '#e45c5c',
    lightest: '#FFF3F3',
  },
  yellow: {
    darkest: '#E0CF2F',
    primary: '#F8E71C',
    secondary: '#fff6ad',
    lightest: '#FFFEEB',
  },
};

export const leading = {
  full: '22px',
  half: '11px',
  third: '8px',
  fourth: '5px',
  eighth: '3px',
};

export const fonts = {
  sans: {
    family: '"Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif',
    weight: {
      light: 300,
      normal: 400,
      bold: 500,
    },
    size: {
      xsmall: '10px',
      small: '12px',
      normal: '14px',
      large: '16px',
      xlarge: '18px',
      xxlarge: '28px',
    },
  },
  icons: css`
    font-family: 'CustomIcons';
    font-style: normal;
    font-weight: normal;
    font-variant: none;
    text-transform: none;
    speak: none;
  `,
};

export const zindex = {
  page: {
    super: 9999,
  },
  modal: {
    above: 9001,
    body: 9000,
    below: 8999,
  },
  component: {
    aboveBase: 101,
    base: 100,
    belowBase: 99,
  },
};

export const settings = {
  page: {
    maxWidth: '1920px',
  },
  mobile: {
    maxWidth: '480px',
  },
};

export const animate = {
  spin: '1.5s',
  fade: '0.3s',
  pulse: '1.5s',
  transition: '0.3s',
};

export const edgeSizes = {
  none: '0px',
  hair: '1px',
  xsmall: '6px',
  small: '12px',
  mediumSmall: '20px',
  medium: '24px',
  large: '48px',
  xlarge: '96px',
};

export function themeLookup(obj, stringMatcher) {
  const path = stringMatcher.split('.');
  let branch = obj;
  path.forEach((str) => {
    if (typeof obj !== 'object' || typeof branch[str] === 'undefined') {
      throw new Error(`themeLookup failed: no value ${stringMatcher} found in object`);
    }
    branch = branch[str];
  });

  return branch;
}
